module.exports = __webpack_public_path__ + "media/images/payments/2checkout-dark-a44a1992589f8b1933554780530eb27a.svg";